export const listPagination = [5, 10, 15, 20, 25, 50];
